import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { defaultStyle } from './default'

const assetHost = window && window.env.assetHost.replace(/\/$/g, '')

const toastifyContainerStyles = ({ theme }) => css`
  label: toastify__container;

  .Toastify {
    &__toast {
      box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.3);
      border-radius: 10px 10px 0 0;

      background: ${theme.colors.white};
      color: ${theme.colors.n600};

      justify-content: center;
      flex-wrap: wrap;

      margin: 0;

      &-body {
        position: relative;

        flex-basis: 50%;
        flex: none;

        font-family: ${theme.font.family.default};
        font-weight: ${theme.font.weight.regular};

        &:before {
          content: '';
          display: block;
          position: absolute;

          top: 0px;
          left: -30px;
          border-radius: ${theme.borderRadius.circle};

          background-size: 12px;
          background-repeat: no-repeat;
          background-position: 50%;

          width: 20px;
          height: 20px;
        }
      }

      &-container {
        bottom: -2px;
        left: 50%;
        width: 95%;

        transform: translateX(-50%);

        padding: 0;
        margin: 0;

        ${theme.media.mega} {
          width: 85%;
        }
      }

      &--error {
        .Toastify__toast-body::before {
          background-color: ${theme.colors.r600};
        }
      }

      &--warning {
        .Toastify__toast-body::before {
          background-color: ${theme.colors.y600};
        }
      }

      &--success {
        .Toastify__toast-body::before {
          background-color: ${theme.colors.p600};
          background-image: url(${assetHost}/assets/images/lmcv/icons/icon-check.svg);
        }
      }
    }
  }
`

export const ToastifyContainer = styled('div')(
  defaultStyle,
  toastifyContainerStyles
)
